var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"12","viewBox":"0 0 11 12"}},[_c('path',{attrs:{"d":"M.79 11.4 0 10.57 4.33 6 0 1.43.79.6l4.33 4.57L9.45.6l.79.83L5.9 6l4.33 4.57-.79.83-4.33-4.57L.79 11.4Z","fill":"currentcolor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }